import axios from "axios";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import { Message } from "../../Models/Message/MessageModels";
import { LangueService } from "./LangueService";
import dayjs from "dayjs";
import { DataMessageIndexation, DataMessageCampagne } from '../../Models/Admin/AdminModels';
import { FichierService } from "../Demande/FichierService";

export function MessageService(){

    // Helper interne : messages de la route commande, filtres par type et par fin incluse (au jour pres)
    async function getMessagesCommandeParTypes(token:string, typesAcceptes:string[]):Promise<Message[]>{
        const messages:Message[]=[];
        try {
            const response = await axios.get(`${URLAPI+'messages/commande'}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const data = response.data['hydra:member'];
            const aujourdhui = dayjs(new Date()).startOf('day');

            if(data.length>0){
                for(const element of data){
                    const typeMessage = element['categorieMessage']['typeMessage']['type'];
                    const finIncluse = !dayjs(element['fin']).startOf('day').isBefore(aujourdhui);
                    if(finIncluse && typesAcceptes.includes(typeMessage)){
                        messages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'],
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            fichiers:element['fichiers']
                        });
                    }
                }
            }
        } catch (error) {
            errorService().handleError('Erreur pour obtention des messages', error);
            return [];
        }
        return messages;
    }

    return{
        async getMessages(token:string){
            let messsages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        messsages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'],
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            typeMessageFixe:element['typeMessageFixe'],
                            fichiers:element['fichiers']
                        })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesCatalogue(token:string){
            let messsages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages/catalogue'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        messsages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'],
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            fichiers:element['fichiers']
                        })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesCategorie(idCategorie:number, token:string){
            let messsages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages/categorie/'+idCategorie}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        messsages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'],
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            typeMessageFixe:element['typeMessageFixe'],
                            fichiers:element['fichiers']
                        })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesForAdmin(token:string){
            let messages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        // const [langues] = await Promise.all([
                        //     LangueService().getLanguesFromURLS(element['langues'], token)
                        // ]);
                        messages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'].map((langue: any)=>{return {'@id':langue}}), //mise sous objet des urls pour mieux exploiter
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            typeMessageFixe:element['typeMessageFixe'],
                            fichiers:element['fichiers']
                        })
                    }
                }

                //gestion langues messages
                const langues = await LangueService().getLangues(token);
                for(const message of messages){
                    if(message.langues && message.langues.length>0){
                        //mise sous objet avec toutes les données des langues rattaché au message
                        message.langues = message.langues.map(langue=>{
                            let result:any;
                            const dtoLangue = langues.find(lang=>lang["@id"]===langue["@id"])
                            if(dtoLangue)result={...langue,
                                id:dtoLangue.id,
                                '@id':dtoLangue["@id"],
                                nom:dtoLangue.nom,
                                abreviation:dtoLangue.abreviation
                            };
                            return result
                        })
                    }
                    //mise à jour du tableau de message
                    messages = messages.map(newMess=>{
                        if(newMess.id===message.id)return message
                        return newMess
                    })
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messages;
        },

        async getMessagesIndexationAvecLangues(token:string){
            let messages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages/indexation'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        messages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'], //mise sous objet des urls pour mieux exploiter
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            typeMessageFixe:element['typeMessageFixe'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            fichiers:element['fichiers']
                        })
                    }
                }

                //gestion langues messages
                const langues = await LangueService().getLangues(token);
                for(const message of messages){
                    if(message.langues && message.langues.length>0){
                        //mise sous objet avec toutes les données des langues rattaché au message
                        message.langues = message.langues.map(langue=>{
                            let result:any;
                            const dtoLangue = langues.find(lang=>lang["@id"]===langue["@id"])
                            if(dtoLangue)result={...langue,
                                id:dtoLangue.id,
                                '@id':dtoLangue["@id"],
                                nom:dtoLangue.nom,
                                abreviation:dtoLangue.abreviation
                            };
                            return result
                        })
                    }
                    //mise à jour du tableau de message
                    messages = messages.map(newMess=>{
                        if(newMess.id===message.id)return message
                        return newMess
                    })
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messages;
        },

        async getMessagesIndexation(token:string){
            let messsages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages/indexation'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        if(element['categorieMessage']['typeMessage']['type']==='Fixe' || element['categorieMessage']['typeMessage']['type']==='Habillage'){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                typeMessageFixe:element['typeMessageFixe'],
                                fichiers:element['fichiers']
                            })
                        }
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesIndexationFixe(token:string){
            let messsages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages/typeMessage/2'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                if(data.length>0){
                    for(const element of data){
                        messsages.push({
                            id:element['id'],
                            '@id':element['@id'],
                            titre:element['titre'],
                            texte:element['texte'],
                            indexValeur:element['indexValeur'],
                            langues:element['langues'],
                            indexReference:element['indexReference'] ?? "",
                            categorieMessage:element['categorieMessage'],
                            forceHorsDiffusion:element['forceHorsDiffusion'],
                            debut:element['debut'],
                            fin:element['fin'],
                            typeMessageFixe:element['typeMessageFixe'],
                            fichiers:element['fichiers']
                        })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesGALECEnCours(token:string){
            return getMessagesCommandeParTypes(token, ['Galec']);
        },

        async getMessagesScamarkEnCours(token:string){
            return getMessagesCommandeParTypes(token, ['Scamark', 'Scamark DROM']);
        },

        async getMessagesCataMidisEnCours(token:string){
            return getMessagesCommandeParTypes(token, ['Cata Midis']);
        },

        async getPremiersMessagesCampagnesGALECAdmin(token:string){
            let messsages:Message[]=[]
            try {
                const responseGALEC = await axios.get(`${URLAPI+'messages/firstTypeMessage/6'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGALEC = responseGALEC.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(dataGALEC.length>0){
                    for(const element of dataGALEC){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }
            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesCampagnesGALECAdmin(token:string){
            let messsages:Message[]=[]
            try {
                const responseGALEC = await axios.get(`${URLAPI+'messages/typeMessage/6'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGALEC = responseGALEC.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(dataGALEC.length>0){
                    for(const element of dataGALEC){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }

                const responseGALECGuadeloupe = await axios.get(`${URLAPI+'messages/typeMessage/11'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGALECGuadeloupe = responseGALECGuadeloupe.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(dataGALECGuadeloupe.length>0){
                    for(const element of dataGALECGuadeloupe){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }

                const responseGALECMartinique = await axios.get(`${URLAPI+'messages/typeMessage/12'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGALECMartinique = responseGALECMartinique.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(dataGALECMartinique.length>0){
                    for(const element of dataGALECMartinique){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesCampagnesSCAMARKAdmin(token:string){
            let messsages:Message[]=[]
            try {
                const responseSCAMARK = await axios.get(`${URLAPI+'messages/typeMessage/5'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataSCAMARK = responseSCAMARK.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(dataSCAMARK.length>0){
                    for(const element of dataSCAMARK){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }

                const responseSCAMARKDROM = await axios.get(`${URLAPI+'messages/typeMessage/10'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataSCAMARKDROM = responseSCAMARKDROM.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(dataSCAMARKDROM.length>0){
                    for(const element of dataSCAMARKDROM){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesCataloguesMIDISAdmin(token:string){
            let messsages:Message[]=[]
            try {
                const response = await axios.get(`${URLAPI+'messages/typeMessage/8'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                // const dateActuelle = dayjs(new Date());

                if(data.length>0){
                    for(const element of data){
                            messsages.push({
                                id:element['id'],
                                '@id':element['@id'],
                                titre:element['titre'],
                                texte:element['texte'],
                                indexValeur:element['indexValeur'],
                                langues:element['langues'],
                                indexReference:element['indexReference'] ?? "",
                                categorieMessage:element['categorieMessage'],
                                forceHorsDiffusion:element['forceHorsDiffusion'],
                                debut:element['debut'],
                                fin:element['fin'],
                                fichiers:element['fichiers']
                            })
                    }

                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des messages',error);
                return [];
            }
            return messsages;
        },

        async getMessagesFromUrlsToAnythingWithoutLanguages(urls:string[], token:string){
            let messsages:Message[]=[]
            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];
        
                        if(data.length>0){
                            for(const element of data){
                                messsages.push({
                                    id:element['id'],
                                    '@id':element['@id'],
                                    titre:element['titre'],
                                    texte:element['texte'],
                                    indexValeur:element['indexValeur'],
                                    langues:element['langues'],
                                    indexReference:element['indexReference'] ?? "",
                                    categorieMessage:element['categorieMessage'],
                                    forceHorsDiffusion:element['forceHorsDiffusion'],
                                    debut:element['debut'],
                                    fin:element['fin'],
                                    fichiers:element['fichiers']
                                })
                            }
        
                        }
        
                    } catch (error) {
                        errorService().handleError('Erreur pour obtention des messages',error);
                        return [];
                    }
                }
            }
            return messsages;
        },

        async deleteMessage(idMessage:number, token:string){
            const responseMessage = await axios.delete(
                `${URLAPI}message/${idMessage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return responseMessage.status;
        },

        async postMessageIndexation(dataMessage:DataMessageIndexation, token:string){
            try {
                let status = 400

                const postMessageObjet = {
                    "titre": dataMessage.titre.trim(),
                    "texte": dataMessage.texte.trim(),
                    "index": dataMessage.index,
                    "indexReference": dataMessage.indexReference ?? " ",
                    "categorieMessage": dataMessage.idCategorieMessage,
                    "typeMessageFixe":dataMessage.idTypeMessageFixe<=0 || dataMessage.typeMessage===3 ?undefined: dataMessage.idTypeMessageFixe,
                    "forceHorsDiffusion":dataMessage.horsDiffusion,
                    // "fichiers":idFichier
                };

                const reponsePOSTMessage = await axios.post(
                    `${URLAPI+'message'}`,
                    postMessageObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
    
                status = reponsePOSTMessage.status

                if(status===201 && reponsePOSTMessage.data['id'] && dataMessage.fichierAudio && dataMessage.fichierAudio.size > 0){
                    status = (await FichierService().postFichierMessage(dataMessage.fichierAudio, reponsePOSTMessage.data['id'],token)).status;
                }
    
                return status;

            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un message", error)
                return 400;
            }
        },

        async postMessageCampagne(dataMessage:DataMessageCampagne, token:string){
            try {
                let status = 400

                // let idFichier:number[] = []
                // if(dataMessage.fichierAudio && dataMessage.fichierAudio.size > 0){
                //     const demandeFichier = await FichierService().postFichierMessage(dataMessage.fichierAudio, dataMessage.id,token);
                //     idFichier.push(demandeFichier.id);
                // }

                //formattage des dates
                const dateDebutFormatte = dayjs(dataMessage.debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(dataMessage.fin).format('YYYY-MM-DD');
                const postMessageObjet = {
                    "titre": dataMessage.titre.trim(),
                    "texte": dataMessage.texte.trim(),
                    "categorieMessage": dataMessage.idCategorieMessage,
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                    // "fichiers":idFichier
                };

                const reponsePOSTMessage = await axios.post(
                    `${URLAPI+'message'}`,
                    postMessageObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );

                status = reponsePOSTMessage.status

                if(status===201 && reponsePOSTMessage.data['id']){
                    if(dataMessage.fichierAudio && dataMessage.fichierAudio.size > 0){
                        status = (await FichierService().postFichierMessage(dataMessage.fichierAudio, reponsePOSTMessage.data['id'],token)).status;
                    }
                }
    
                return status;

            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un message", error)
                return 400;
            }
        },

        async patchMessageIndexationAdmin(dataMessage:DataMessageIndexation, token:string){
            try {

                let patchMessageObjet:any={};

                if(dataMessage.modifFichier){
                    if(dataMessage.fichiersMessage.length>0){
                        await FichierService().deleteFichier(dataMessage.fichiersMessage[0].id, token);
                    }
                    let idFichier:number[] = []
                    if(dataMessage.fichierAudio && dataMessage.fichierAudio.size > 0){
                        const demandeFichier = await FichierService().postFichierMessage(dataMessage.fichierAudio, dataMessage.id,token);
                        idFichier.push(demandeFichier.id);
                    }

                    patchMessageObjet = {
                        "titre": dataMessage.titre.trim(),
                        "texte": dataMessage.texte.trim(),
                        "index": dataMessage.index.trim(),
                        "indexReference": dataMessage.indexReference.trim() ?? " ",
                        "categorieMessage": dataMessage.idCategorieMessage,
                        "typeMessageFixe":dataMessage.idTypeMessageFixe<=0?undefined:dataMessage.idTypeMessageFixe,
                        "forceHorsDiffusion":dataMessage.horsDiffusion,
                        "fichiers":idFichier
                    };
                }else{
                    patchMessageObjet = {
                        "titre": dataMessage.titre,
                        "texte": dataMessage.texte,
                        "index": dataMessage.index,
                        "indexReference": dataMessage.indexReference ?? " ",
                        "categorieMessage": dataMessage.idCategorieMessage,
                        "typeMessageFixe":dataMessage.idTypeMessageFixe<=0?undefined:dataMessage.idTypeMessageFixe,
                        "forceHorsDiffusion":dataMessage.horsDiffusion,
                    };
                }

                const reponsePOSTMessage = await axios.patch(
                    `${URLAPI+'message/'+dataMessage.id}`,
                    patchMessageObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return reponsePOSTMessage.status;
            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un message", error)
                return 400;
            }
        },

        async patchMessageCampagne(dataMessage:DataMessageCampagne, token:string){
            try {

                let patchMessageObjet:any={};

                if(dataMessage.modifFichier){
                    if(dataMessage.fichiersMessage.length>0){
                        await FichierService().deleteFichier(dataMessage.fichiersMessage[0].id, token);
                    }
                    if(dataMessage.fichierAudio && dataMessage.fichierAudio.size > 0){
                        await FichierService().postFichierMessage(dataMessage.fichierAudio, dataMessage.id,token);
                    }
                }
                //formattage des dates
                const dateDebutFormatte = dayjs(dataMessage.debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(dataMessage.fin).format('YYYY-MM-DD');

                patchMessageObjet = {
                    "titre": dataMessage.titre.trim(),
                    "texte": dataMessage.texte.trim(),
                    "categorieMessage": dataMessage.idCategorieMessage,
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                };

                const reponsePOSTMessage = await axios.patch(
                    `${URLAPI+'message/'+dataMessage.id}`,
                    patchMessageObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return reponsePOSTMessage.status;
            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un message", error)
                return 400;
            }
        },

        async patchMessageDate(idMess:number, debut:Date, fin:Date, token:string){
            try {
                //formattage des dates
                const dateDebutFormatte = dayjs(debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(fin).format('YYYY-MM-DD');

                let patchMessageObjet = {
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                };

                const reponsePOSTMessage = await axios.patch(
                    `${URLAPI+'message/'+idMess}`,
                    patchMessageObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return reponsePOSTMessage.status;
            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un message", error)
                return 400;
            }
        }
    }
}
